import React from 'react';
import Svg, {Path} from 'react-native-svg';
import {Props} from '../SvgProps';

const RepairsMainIcon = ({color = '#707070'}: Props) => (
  <Svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <Path
      d="M14.6966 6.30052C14.5133 6.48745 14.4107 6.73877 14.4107 7.00052C14.4107 7.26227 14.5133 7.51359 14.6966 7.70052L16.2966 9.30052C16.4835 9.48374 16.7348 9.58638 16.9966 9.58638C17.2583 9.58638 17.5096 9.48374 17.6966 9.30052L20.8026 6.19552C21.1226 5.87352 21.6656 5.97552 21.7856 6.41352C22.0877 7.51239 22.0706 8.67459 21.7363 9.76411C21.4021 10.8536 20.7644 11.8254 19.8979 12.5658C19.0315 13.3061 17.9721 13.7844 16.8438 13.9446C15.7155 14.1048 14.5648 13.9404 13.5266 13.4705L5.61656 21.3805C5.21874 21.7782 4.67922 22.0016 4.11671 22.0015C3.55419 22.0014 3.01475 21.7778 2.61706 21.38C2.21937 20.9822 1.996 20.4427 1.99609 19.8802C1.99619 19.3176 2.21974 18.7782 2.61756 18.3805L10.5276 10.4705C10.0577 9.43223 9.89327 8.2816 10.0535 7.15327C10.2137 6.02493 10.692 4.96557 11.4323 4.09913C12.1727 3.2327 13.1444 2.59503 14.234 2.26074C15.3235 1.92646 16.4857 1.90938 17.5846 2.21152C18.0226 2.33152 18.1246 2.87352 17.8036 3.19552L14.6966 6.30052Z"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default RepairsMainIcon;
